import { DestroyRef, Directive, inject, TemplateRef } from '@angular/core';
import { HeaderPortalService } from './header-portal.service';

/**
 * Projects a template into a header's right-actions area via {@link HeaderPortalService}.
 * Auto-registers on creation and unregisters on destroy.
 *
 * @example
 * ```html
 * <!-- Route component template -->
 * <ng-template coinHeaderPortal>
 *   <coin-v2-button (click)="state.create()" [text]="'general.create' | translate" />
 *   <customer-filter-sort-bar [hideSorting]="true" />
 * </ng-template>
 *
 * <!-- Header component template -->
 * <ng-template #rightActions>
 *   @if (headerPortalService.template()) {
 *     <ng-container *ngTemplateOutlet="headerPortalService.template()" />
 *   }
 * </ng-template>
 * ```
 */
@Directive({
  selector: 'ng-template[coinHeaderPortal]',
  standalone: true
})
export class HeaderPortalDirective {
  private readonly service = inject(HeaderPortalService);
  private readonly template = inject(TemplateRef);

  constructor() {
    this.service.register(this.template);
    inject(DestroyRef).onDestroy(() => this.service.unregister(this.template));
  }
}
